import { values, join } from 'lodash/fp'

export default (errors: { [key: string]: string }) => join(' ', values(errors))
